import BaseService from '@/service/modules/BaseService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import OrderInfo from '@/model/modules/OrderInfo'
import BaseInfo from '@/model/modules/BaseInfo'

export default class OrderService extends BaseService {
  protected static baseUrl: string = '/order'

  public static list(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<OrderInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<OrderInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<OrderInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }

  public static export(example: { [index: string]: any }): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios.get(this.baseUrl + '/export', {
        params: example
      }).then(resp => {
        resolve(resp.data.body.body)
      })
    })
  }

  public static updateOrderStatus(orderList: OrderInfo[], newStatus: string): Promise<string[]> {
    const orderIdList: number[] = []
    orderList.forEach((orderItem: OrderInfo) => {
      orderIdList.push(orderItem.id)
    })
    return new Promise<string[]>((resolve, reject) => {
      axios.post(this.baseUrl + '/update-order-status', {
        orderIds: orderIdList,
        type: newStatus
      })
        .then(resp => {
          if (newStatus === '4' || newStatus === '5' || newStatus === '6' || newStatus === '7') {
            resolve([resp.data.body])
          }
          resolve(resp.data.body)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }

  public static deleteOrderList(orderList: OrderInfo[]): Promise<void> {
    let deleteList: string = ''
    orderList.forEach((orderItem: OrderInfo) => {
      if (deleteList !== '') {
        deleteList += '&'
      }
      deleteList += 'ids=' + orderItem.id
    })
    return new Promise<void>((resolve, reject) => {
      axios.delete(this.baseUrl + '/deleteList?' + deleteList)
        .then(resp => {
          resolve()
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  public static save(i: BaseInfo): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios.request({
        url: this.baseUrl + (i.id === undefined ? '/save' : '/update'),
        method: i.id === undefined ? 'post' : 'put',
        data: i
      })
        .then(resp => {
          if (resp.data.errCode === '500') {
            resolve(resp.data.errMsg)
          }
          resolve('')
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}
